import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "EmptySubmittedMessage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "MessageContainer" }, [
      _createElementVNode("img", {
        src: "https://monet-prtl-co.imgix.net/Endor/ERT/empty-submitted.svg",
        class: "EmptyImage"
      }),
      _createElementVNode("p", null, "Don't forget to submit them once you have reviewed everything!")
    ], -1 /* CACHED */)
  ])))
}